import { instance } from './_config.js'


const getAsingeIdx = async (obj) => {
    try {
        const rs = await instance.get(`/asingne_idx`, { params: obj })
        if (rs.data?.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return null
    }
}


const updateAsingeIdx = async (obj) => {
    try {
        const rs = await instance.post(`asingne_idx`, obj)
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


const deleteAsingeIdx = async (obj) => {
    try {
        const rs = await instance.delete(`asingne_idx`, { data: obj })
        if (rs.data) {
            return rs.data.data
        }
    }
    catch (err) {
        console.log(err)
        return false
    }
}


export { getAsingeIdx, updateAsingeIdx, deleteAsingeIdx }